module.exports = __webpack_public_path__ + "1.0.0-d5234419/img/offline-report-2.8276525f.svg";